import Swiper, { Navigation, Pagination } from 'swiper';
const init = async (parent) => {
  return new Promise((resolve) => {
    // Get all team swipers on the page
    const swiperTeam = document.querySelectorAll('.swiper-team');

    // Initialize every swiper
    swiperTeam.forEach((swiperEl, index) => {
      const section = swiperEl.closest('.section');

      const sw = new Swiper(swiperEl, {
        modules: [Navigation, Pagination],
        watchOverflow: true,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev'),
        },
        grabCursor: true,
        speed: swiperEl.dataset.speed ?? 640,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3.2,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 4.2,
            spaceBetween: 40,
          },
        },
        /*on: {
                  init: () => {
                    console.info(`${section.id} Team Slider ready`, swiperEl.dataset);
                  },
                },*/
      });
    });

    return resolve('Team component loaded');
  });
};

export { init };
